<template>
  <div class="bottom mt20">
    
    <div class="w1200">
      <div class="bottom_menu">
        <router-link :to="{name:'index'}">首页</router-link>
        <span>|</span>
        <router-link :to="{name:'aboutus'}">关于我们</router-link>
        <span>|</span>
        <router-link :to="{name:'dynamic'}">本网动态</router-link>
        <span>|</span>
         <router-link :to="{name:'logisticsnews'}">热点新闻</router-link>
        <span>|</span>
        <router-link :to="{name:'proclamation'}">通知公告</router-link>
        <span>|</span>
        <router-link :to="{name:'version'}">版本迭代</router-link>
      </div>
      <div>免费客服热线：0530-6020721</div>
      <div>
        <a target="_blank"  href="http://wpa.qq.com/msgrd?v=3&amp;uin=1371062109&amp;site=qq&amp;menu=yes">
          <img
            border="0"
            src="/static/images/QQT.gif"
            alt="点击这里给我发消息"
            title="点击这里给我发消息"
            style="vertical-align: -8px;"
          />
        </a>
      </div>
      <div>
        <span>7*24客服电话：0530-6020721</span>
        <span>纠错电话：0530-6020721</span>
        <span>电子邮件：hzwlysxh@163.com</span>
      </div>
      <div>
        <span>主办单位：菏泽市物流运输协会 唐山唐联电子商务有限公司</span>
      </div>
      <div>
        <span>
          <a href="http://beian.miit.gov.cn/" target="_blank">冀ICP备11009155号-95</a>
        </span>
        <span>网站制度</span>
        <span>证照信息公示</span>
      </div>
      <div>
        <span><a href="https://zzlz.gsxt.gov.cn/businessCheck/verifKey.do?showType=p&serial=911302937554531049-SAIC_SHOW_1000009113029375545310491607474289569&signData=MEQCINtNGv5f9qrbeNH3F8MYLqDVGl2gM6ToGQh6ezFepEGAAiDWDoHKQloTDvyTYuDMGgzGPTBsDGXrEyRBIQVF3lDhAg==" target="_blank"><img src="/static/images/lztb.png"></a></span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "homebottom"
};
</script>
<style scoped>
.bottom {
  background: #454545;
  text-align: center;
  color: #a8a8a8;
  line-height: 30px;
  padding: 20px 0 30px;
}
.bottom a {
  color: #999;
  cursor: pointer;
}
.bottom span {
  padding: 0 10px;
}
.bottom_top {
  border-bottom: 1px solid #626262;
  height: 103px;
}
.bottom_top ul li {
  width: 26%;
  float: left;
  text-align: left;
  padding: 0 2% 0 5%;
  height: 62px;
  border-right: 1px solid #727272;
}

.bottom_top ul li:last-child {
  border: 0;
}
.bottom_top ul li img {
  float: left;
  margin-right: 20px;
}
.bottom_top ul li b {
  display: block;
  font-size: 16px;
  font-weight: normal;
  line-height: 20px;
}
.bottom_top ul li span {
  padding: 0;
  line-height: 18px;
  display: block;
  margin-top: 5px;
}
.bottom_menu {
  height: 30px;
  padding: 8px 0;
  text-align: center;
}
.bottom_menu a {
  line-height: 30px;
}
.bottom_menu span {
  padding: 0 18px;
}
</style>


// WEBPACK FOOTER //
// src/components/Public/homeBottom.vue